var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M15 7.533 8 1 1 7.533"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.867 15h-1a1 1 0 0 0 1 1zM6.6 15v1a1 1 0 0 0 1-1zm0-3.733v-1h-1v1zm2.8 0h1v-1h-1zM9.4 15h-1a1 1 0 0 0 1 1zm3.733 0v1a1 1 0 0 0 1-1zM1.867 6v9h2V6zm1 10H6.6v-2H2.867zM7.6 15v-3.733h-2V15zm-1-2.733h2.8v-2H6.6zm1.8-1V15h2v-3.733zM9.4 16h3.733v-2H9.4zm4.733-1V6h-2v9z"
  })));
};
export default SvgHome;